export const SeasonHeader = (props: { seasonName: string | undefined }) => {
    return (
        <h1>{props.seasonName}</h1>
    )
};
